/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCTimelineItemSearchBodyParams } from '../models/TCTimelineItemSearchBodyParams';
import type { TCTimelineItemSearchResponse } from '../models/TCTimelineItemSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmTimelineItemsService {
    /**
     * Search timeline items with pagination, filtering, and sorting
     * @param requestBody Search parameters for filtering, sorting, and pagination
     * @returns TCTimelineItemSearchResponse Ok
     * @throws ApiError
     */
    public static searchTimelineItems(
        requestBody: TCTimelineItemSearchBodyParams,
    ): CancelablePromise<TCTimelineItemSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/timeline-items/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
